import { joinPath } from '../../util/storageHelpers';

const ROOT = '@NotificationLogs';
const getKey = id => joinPath(ROOT, id);

export default {
  getById(notificationTemplateId) {
    const key = getKey(notificationTemplateId);

    // wrapped this in a promise to replicate AsyncStorage
    const notificationLog = new Promise((resolve, reject) =>
      resolve(JSON.parse(window.localStorage.getItem(key))),
    );

    return notificationLog;
  },
  update(notificationTemplateId, notificationTimes) {
    window.localStorage.setItem(
      getKey(notificationTemplateId),
      JSON.stringify(notificationTimes),
    );
  },
  delete(notificationTemplateId) {
    const key = getKey(notificationTemplateId);
    window.localStorage.removeItem(key);
  },
};



// WEBPACK FOOTER //
// ./src/store/notificationLog/NotificationLogService.js